import { createContext } from "react";

const CountrySelectContext = createContext([]);

export default CountrySelectContext;
